import { type Theme } from "@mui/material";

import { type MuiThemeComponentOverride } from "./types";

export function getMuiDialogActions(theme: Theme): MuiThemeComponentOverride<"MuiDialogActions"> {
  return {
    MuiDialogActions: {
      styleOverrides: {
        root: {
          backgroundColor: theme.palette.brand.grey[100].main,
          padding: "16px",
        },
      },
    },
  };
}
